export namespace SortTranslations {
  export const sorting = {
    sort: 'sort',
    sortingNoOptionsText: 'sortingNoOptionsText',
    sortingNoOptionsSubtext: 'sortingNoOptionsSubtext',
  } as const;
}
